import { render, staticRenderFns } from "./TemplateManager.vue?vue&type=template&id=2d4c8b84&scoped=true&"
import script from "./TemplateManager.vue?vue&type=script&lang=js&"
export * from "./TemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./TemplateManager.vue?vue&type=style&index=0&id=2d4c8b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c8b84",
  null
  
)

export default component.exports